import { useEffect, useRef, useState, useMemo, useCallback} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import { getOrderList, localStatus, getSearcherCompany, updateSearchCompany, getUploadedFileDetails, filterOrders as filterOrdersService } from '../../services/order.service'
import Loading from '../../components/loading.component'
import { OrderModel } from '../../models/orders/order.model'
import { useAuth } from '../../contexts/auth.context'
import { OrderTable } from '../../components/order-table.component'
import { type MRT_ColumnDef } from 'material-react-table'
import { Link, useNavigate } from 'react-router-dom'
import { TopFilterItem } from '../../components/top-filter/top-filter-item.component'
import { DefaultTableModel, ITableModel } from '../../models/orders/table.model'
import { UTCNoTime, base64Encode, xorEncrypt } from '../../utils/global.utils'
import Popup from '../../components/message-form/pop-up-form'
import { RenderTransactionStatusRow } from './RenderTransactionStatusRow'
import { RenderPaidRow } from './RenderPaidRow'
import { RenderAssignmentRow } from './RenderAssignmentRow'
import { RenderShieldRow } from './RenderShieldRow'
import { RenderRushActionRow } from './RenderRushActionRow'

const rushPriority = ['NoRush', 'Rush', 'RushPlus']
let pagination = true

export const ORDER_STATUS = {
  'received': {
    title: 'Pending',
    showWizard: true,
    icon: '/media/ATR/icons/icons8-pending-50.svg',
    size: 0,
    data: [] as OrderModel[]
  },
  'progress': {
    title: 'In Progress',
    showWizard: true,
    icon: '/media/ATR/icons/icons8-in-progress-50.svg',
    size: 0,
    data: [] as OrderModel[]
  },
  'done': {
    title: 'Completed',
    showWizard: false,
    icon: '/media/ATR/icons/icons8-checkmark-50.svg',
    size: 0,
    data: [] as OrderModel[]
  },
  'ignore': {
    title: 'Cancelled',
    showWizard: false,
    icon: '/media/ATR/icons/icons8-cancel-64.svg',
    size: 0,
    data: [] as OrderModel[]
  },
  'all': {
    title: 'All',
    showWizard: false,
    icon: '/media/ATR/icons/job.svg',
    size: 0,
    data: [] as OrderModel[]
  }
}

const TAB_STATUS_WHITELIST: Record<string, string[]> = {
  done: ['complete'],
  progress: ['on hold', 'in progress'],
  received: ['pending'],
}

type StateProps = {
  tab: string;
}

const ACTIVE_TAB_KEY = 'dashboard_active_tab'
const SESSION_ACTIVE_KEY = 'dashboard_session_active'

const saveActiveTab = (tab: string) => {
  sessionStorage.setItem(ACTIVE_TAB_KEY, tab)
}

const getActiveTab = (): string => {
  const saved = sessionStorage.getItem(ACTIVE_TAB_KEY)
  if (saved && Object.keys(ORDER_STATUS).includes(saved)) return saved
  return 'received'
}

const renderPropertyRow = (params: any) => <span>{params.row?.property}</span>

const renderProducttRow = (params: any) => {
  const { orderID, tab, transaction_searchType, transactionType_type } = params;
  const encodeOid = base64Encode(xorEncrypt(orderID.toString()));
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Link
        to={`/orders/details/${encodeOid}`}
        state={{ tab, returnTo: '/dashboard' }}
        className='text-decoration-underline'
      >
        {transaction_searchType}
      </Link>
      <div>{transactionType_type}</div>
    </div>
  )
}

const renderFileNumberRow = (params: any) => {
  const { orderID, tab } = params.row;
  const encodeOid = base64Encode(xorEncrypt((orderID || params.row.orderID).toString()));
  const orderHistoryState = {
    tab,
    address: params.row.property || '',
    state: params.row.stateName || params.row.state || '',
    county: params.row.county || '',
    customerOrderId: params.row.fileNumber || '',
    reportingOrgId: params.row.reportingOrgId || '',
    returnTo: '/dashboard',
  };
  const queryString = new URLSearchParams({
    address: orderHistoryState.address,
    state: orderHistoryState.state,
    county: orderHistoryState.county,
    customerOrderId: orderHistoryState.customerOrderId,
    reportingOrgId: orderHistoryState.reportingOrgId,
  }).toString();
  return (
    <Link
      to={`/orders/details/orderHistory/${encodeOid}?${queryString}`}
      state={orderHistoryState}
      className='text-decoration-underline'
    >
      {params.row.fileNumber}
    </Link>
  )
}

const renderNotificationsRow = (params: any) => {
  const { tab } = params.row;
  const encodeOid = base64Encode(xorEncrypt(params.row.orderID.toString()));
  return (
    <div>
      {params.row.notifications && params.row.notifications === true ?
        <Link
          to={`/orders/details/${encodeOid}`}
          state={{ tab, view: true, returnTo: '/dashboard' }}
          className="d-inline-block"
        >
          <img
            src={"/media/ATR/icons/Notes.png"}
            alt='notes'
            style={{ width: 35, height: 35, marginLeft: 6, display: 'block' }}
          />
        </Link>
        : ''
      }
    </div>
  )
}

const RenderShield = (params: any, fileDetails: any) => {
  
  return (
    <RenderShieldRow params={params} fileDetails={fileDetails} />
  )
}

const RenderOrderStatus = (cell: any) => {  
  let status = cell?.status 
  if (cell?.status === 'on Hold') {
    status = 'In Progress'
  }
  return (
    <RenderTransactionStatusRow value={status} />
  )
}

const RenderRushAction = (params: any, cardclicked: any, auth: any, results: any, navigate: any, setShowPopup: any, setModalOpen: any) => {
  
  return (
    <RenderRushActionRow params={params} tableStateType={cardclicked} auth={auth} results={results} navigate={navigate} setShowPopup={setShowPopup} setModalOpen={setModalOpen} />
  )
}

const RenderAssignment = (params: any, fileDetails: any, results: any, updateSearchCompany: any, popupState: { showPopup: any, setShowPopup: any, setPopupMessage: any }, refreshOrders: () => void) => {
  
  return (
      <RenderAssignmentRow params={params} fileDetails={fileDetails} results={results} updateSearchCompany={updateSearchCompany} showPopup={popupState.showPopup} setShowPopup={popupState.setShowPopup} setPopupMessage={popupState.setPopupMessage} refreshOrders={refreshOrders} />
  )
}

const RenderPaid = (params: any, addPayment: any, removePayment: any) => {
  
  return (
    <RenderPaidRow params={params} addPayment={addPayment} removePayment={removePayment} />
  )
}

const sortByRushPriority = (orders: OrderModel[]) =>
  [...orders].sort((a, b) => {
    const ap = a.rushPriority ?? 0
    const bp = b.rushPriority ?? 0
    return bp - ap
  })

const mapOrderToRow = (
  data: OrderModel,
  index: number,
  tab: string
) => {
  const row = data as any
  return {
    id: index + 1,
    transactionId: row.transaction_id ?? 0,
    orderID: row.tgOrder_tgOrderId ?? 0,
    fileNumber: row.transaction_agencyOrderId ?? 0,
    property: row.transaction_address ?? '',
    county: row.transaction_county ?? '',
    state: row.transaction_state ?? '',
    city: row.transaction_city ?? '',
    tab,
    paid: Boolean(row.transaction_paid),
    oldPaid: Boolean(row.transaction_paid),
    product: `${row.transaction_searchType}, ${row.transactionType_type}`,
    orderDate: (row.transaction_transactionDateTime ?? null) === null ? null : UTCNoTime(row.transaction_transactionDateTime),
    deliveredDate: (row.transaction_completeMovementDate ?? null) === null ? null : UTCNoTime(row.transaction_completeMovementDate),
    closingDate: (row.transaction_currentDueDate ?? null) === null ? null : UTCNoTime(row.transaction_currentDueDate),
    assignedTo: {
      name: row.transaction_searchCompanyName,
      id: row.transaction_searchCompanyId,
    },
    notifications: row.transaction_comments,
    source: row.source ?? '',
    rush: row.rushPriority,
    rushAction: row.rushAction ?? '',
    reportingOrgId: row.transaction_reportingOrgId ?? '',
    rushPriority: row.transaction_rush ?? '',
    transaction_searchType: row.transaction_searchType ?? '',
    transactionType_type: row.transactionType_type ?? '',
    transaction_currentProcessingQueue: row.transaction_currentProcessingQueue ?? '',
    transaction_county_search_status: row.transaction_county_search_status?? '',
    transaction_status: row.transaction_status ?? '',
    status: row.status ?? '',
    stateName: row.transaction_stateName ?? '',
  }
}

const resetOrderStatusData = (
  status: typeof ORDER_STATUS
): typeof ORDER_STATUS => {
  return (Object.keys(status) as Array<keyof typeof ORDER_STATUS>).reduce(
    (acc, key) => {
      acc[key] = { ...status[key], data: [] }
      return acc
    },
    {} as typeof ORDER_STATUS
  )
}

const createDashboardColumn = (
  accessorKey: string,
  header: string,
  size: number,
  overrides: Record<string, any> = {}
): MRT_ColumnDef<any> => ({
  accessorKey,
  header,
  size,
  minSize: size,
  ...overrides,
})

const DashboardPage = () => {
  const {auth} = useAuth();
  const navigate = useNavigate();
  const initialStatus = getActiveTab();

  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [status, setStatus] = useState<string>(initialStatus);
  const [orderStatus, setOrderStatus] = useState(ORDER_STATUS);
  const [tableState, setTableState] = useState<ITableModel>(DefaultTableModel);
  const [results, setResults] = useState<any[]>([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [cardclicked, setCardclicked] = useState(initialStatus);
  const [modalOpen, setModalOpen] = useState(false);
  const [filtered, setFiltered] = useState(false);
  const [addedPayments, setAddedPayments] = useState<any[]>([]);
  const [fileDetails, setFileDetails] = useState<any[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableInstanceKey, setTableInstanceKey] = useState(0);
  const statusRef = useRef<string>(initialStatus);
  const fileDetailsRef = useRef(fileDetails);
  useEffect(() => {
    fileDetailsRef.current = fileDetails;
  }, [fileDetails]);

  useEffect(() => {
    if (auth?.api_token) {
      const isSessionActive = sessionStorage.getItem(SESSION_ACTIVE_KEY);
      if (!isSessionActive) {
        sessionStorage.setItem(SESSION_ACTIVE_KEY, 'true');
        sessionStorage.setItem(ACTIVE_TAB_KEY, 'received');
        statusRef.current = 'received';
        setStatus('received');
        setCardclicked('received');
      }
    }
  }, [auth?.api_token]);

  const handleClosePopup = () => setShowPopup(false);

  const addPayment = useCallback((payment: any) => {
    setAddedPayments(prev => [...prev, payment]);
  }, []);

  const removePayment = useCallback((payment: any) => {
    setAddedPayments(prev => prev.filter(p => p !== payment));
  }, []);

  const updateStatus = useCallback((newStatus: string) => {
    statusRef.current = newStatus;
    saveActiveTab(newStatus);
    setStatus(newStatus);
    setCardclicked(newStatus);
    setTableInstanceKey(prev => prev + 1);
  }, []);

  useEffect(() => {
    getSearcherCompany().then(results => {
      if (results.success.msg.length > 0) setResults(results.success.msg)
    })
  }, [])

  const updatePageState = (prop: string, value: any) => {
    setTableState(old => ({ ...old, [prop]: value }))
  }

  const filterOrders = (event: any, status: string) => {
    setFiltered(false);
    updateStatus(status);
    fetchOrderList(status);
  }

  const refreshOrders = useCallback(() => {
    fetchOrderList(statusRef.current);
  }, []);

  const columns = useMemo<MRT_ColumnDef<any>[]>(() => [
    createDashboardColumn('paid', 'Paid', 46, { enableColumnFilter: false, Cell: ({ row }: any) => RenderPaid(row.original, addPayment, removePayment) }),
    createDashboardColumn('fileNumber', 'File Number', 96, { Cell: ({ row }: any) => renderFileNumberRow({ row: row.original }) }),
    createDashboardColumn('product', 'Product', 100, { Cell: ({ row }: any) => renderProducttRow(row.original) }),
    createDashboardColumn('property', 'Property', 108, { Cell: ({ row }: any) => renderPropertyRow({ row: row.original }) }),
    createDashboardColumn('state', 'State', 48),
    createDashboardColumn('city', 'Town', 68),
    createDashboardColumn('county', 'County', 76),
    createDashboardColumn('orderDate', 'Order Date', 84, { muiTableBodyCellProps: { align: 'center' }, sortingFn: (rowA: any, rowB: any) => new Date(rowA.original.orderDate).getTime() - new Date(rowB.original.orderDate).getTime() }),
    createDashboardColumn('deliveredDate', 'Delivered Date', 90, {
      muiTableBodyCellProps: { align: 'center' },
      Cell: ({ row }: any) => {
        const value = row.original.deliveredDate;
        return value || 'N/A';
      },
      sortingFn: (rowA: any, rowB: any) => {
        const a = rowA.original.deliveredDate
          ? new Date(rowA.original.deliveredDate).getTime()
          : 0;
        const b = rowB.original.deliveredDate
          ? new Date(rowB.original.deliveredDate).getTime()
          : 0;
        return a - b;
      }
    }),
    createDashboardColumn('closingDate', 'Due Date', 84, { muiTableBodyCellProps: { align: 'center' }, sortingFn: (rowA: any, rowB: any) => new Date(rowA.original.closingDate).getTime() - new Date(rowB.original.closingDate).getTime() }),
    createDashboardColumn('notifications', 'Notes', 44, { Cell: ({ row }: any) => renderNotificationsRow({ row: row.original }) }),
    createDashboardColumn('assignedTo', 'Assigned To', 110, { Cell: ({ row }: any) => RenderAssignment(row.original, fileDetails, results, updateSearchCompany, { showPopup, setShowPopup, setPopupMessage }, refreshOrders) }),
    createDashboardColumn('shield', '', 42, { muiTableBodyCellProps: { align: 'center' }, Cell: ({ row }: any) => RenderShield(row.original, fileDetailsRef.current) }),
    createDashboardColumn('status', 'Status', 92, { muiTableHeadCellProps: { className: 'status-header-cell' }, muiTableBodyCellProps: { align: 'center' }, Cell: ({ row }: any) => RenderOrderStatus(row.original) }),
    createDashboardColumn('source', 'Source', 58),
    createDashboardColumn('rush', 'Rush', 50),
    createDashboardColumn('rushAction', 'Action', 52, { muiTableHeadCellProps: { className: 'action-header-cell' }, Cell: ({ row }: any) => RenderRushAction(row.original, cardclicked, auth, results, navigate, setShowPopup, setModalOpen) }),
    createDashboardColumn('transactionId', 'traID', 64)
  ], [
    addPayment, removePayment, results, cardclicked, showPopup,fileDetails, auth, navigate,
  ]);

  const hiddenColumns = {
    rush: false,
    rushAction: false,
    closingDate: false,
    deliveredDate: false,
    assignedTo: false,
    transactionId: false,
    shield: false
  };

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  useEffect(() => {
    if (auth && auth.api_token) {
      fetchOrderList(initialStatus)
    }
    setTableState((old) => ({
      ...old,
      columns: columns,
      pagination: pagination,
      hiddenColumns: hiddenColumns,
      settings: {
        ...old.settings,
        breadcrumb: 'Orders',
        showCount: true,
        showButton: process.env.REACT_APP_ENV == 'fuckingshit',
        buttonText: 'New Order',
        buttonLink: '/orders/new',
        hideComponents: false,
        updatePageState: updatePageState,
      },
    }))
  }, [])

  useEffect(() => {
    const currentStatus = statusRef.current;
    if (currentStatus) {

const sortedOrders = sortByRushPriority(
  orderStatus[currentStatus as keyof typeof orderStatus].data
)

      let tmpRows: any = []
      if (sortedOrders.length !== 0) {

 tmpRows = sortedOrders.map((data, index) =>
  mapOrderToRow(data, index, currentStatus)
)

      }          
      setTableState(old => ({
        ...old,
        rows: tmpRows,
        rowCount: results?.length > 0 ? results[0].count : 0,
        settings: {
          ...old.settings,
          title: `${orderStatus[currentStatus as keyof typeof orderStatus].title} Orders`,
        },
      }))
    }
  }, [orderStatus])

  useEffect(() => {
    if (status && !filtered) {
      const rushAction = status === 'progress' || status === 'received' || status === 'done'
      setAddedPayments([])
      setTableState(old => ({
        ...old,
        page: 0,
        status,
        filterText: null,
        hiddenColumns: {
          ...old.hiddenColumns,
          paid: status === 'done',
          deliveredDate: status === 'done' || status === 'all',
          closingDate: status === 'all' || status === 'progress' || status === 'received',
          assignedTo: true,
          rushAction,
          shield: status !== "received"
        },
      }));
    }
  }, [status]);

  useEffect(() => {
    if (status) {
      if (orderStatus[status as keyof typeof orderStatus].size > 0) {
        if (tableState.rows.length > 0) setTableState(old => ({ ...old, loading: false }));
      } else {
        setTableState(old => ({ ...old, loading: false }));
      }
    }
    if (tableState.rowCount === 0) setTableState(old => ({ ...old, loading: false }));
  }, [tableState.rows]);

  useEffect(() => {
    if (tableState.filterText && tableState.filterText.trim().length > 0) {
      if (tableState.filterText === '_reset') {
        fetchOrderList(status);
      } else {
        setFiltered(true);
        updateStatus('all');
        filterData('all');
      }
    }
  }, [tableState.filterText]);

  const updateOrderStatus = (
    tmpStatus: string | undefined,
    response: any,
    tmpOrderStatus: any,
    isFiltered: boolean
  ) => {
    if (tmpStatus && response.results) {
      const res: OrderModel[] = response.results;
      const companyList = res
        .filter((item: any) => item.transaction_searchCompanyId && item.transaction_searchCompanyName)
        .map((item: any) => ({ id: item.transaction_searchCompanyId, name: item.transaction_searchCompanyName }))
        .filter((company: any, index: number, self: any[]) =>
          index === self.findIndex((c: any) => c.id === company.id)
        );
      if (companyList.length > 0) {
        Promise.all(
          companyList.map((company: any) =>
            getUploadedFileDetails(company.id).then((r: any) => ({ company_id: company.id, res: r.files }))
          )
        )
          .then(results => setFileDetails(results))
          .catch(error => console.error('Error fetching file details:', error))
      }
      const resolvedStatus = tmpStatus;
      const allowedStatuses = TAB_STATUS_WHITELIST[resolvedStatus];
      const filteredRes = allowedStatuses
        ? res.filter((order: any) => allowedStatuses.includes(String(order.status ?? '').trim().toLowerCase()))
        : res;
      tmpOrderStatus[resolvedStatus].data = filteredRes.map(order => {
        const orderStatusKey =
          localStatus(order.transaction_currentProcessingQueue, order.transaction_status)?.status ||
          'received';

        return {
          ...order,
          finalStatus: orderStatusKey,
          rushPriority: order.transaction_rush ? rushPriority.indexOf(order.transaction_rush) + 1 : 0,
        };
      });
      if (!isFiltered) tmpOrderStatus[resolvedStatus].size = response.count
    }
    return tmpOrderStatus;
  }

  const fetchOrderList = (tmpStatus: string | undefined) => {
let tmpOrderStatus = resetOrderStatusData(orderStatus)
    setTableLoading(true)
    setTableState(old => ({ ...old, loading: true }))
    getOrderList(tmpStatus)
      .then(response => {
        if (response) {
          if (tmpStatus && response.results)
            tmpOrderStatus = updateOrderStatus(tmpStatus, response, tmpOrderStatus, false);
          if (response.rows) {
            const rows = response.rows
            Object.keys(rows).forEach(
              key => (tmpOrderStatus[key as keyof typeof ORDER_STATUS].size = rows[key])
            )
          }
        }
      })
      .finally(() => {
        setOrderStatus(tmpOrderStatus)
        if (tmpStatus) {
          const currentData = tmpOrderStatus[tmpStatus as keyof typeof tmpOrderStatus]?.data ?? []
const sorted = sortByRushPriority(currentData)
          if (sorted.length > 0) {

const tmpRows = sorted.map((data, index) =>
  mapOrderToRow(data, index, tmpStatus)
)

            setTableState(old => ({
              ...old,
              rows: tmpRows,
              settings: {
                ...old.settings,
                title: `${tmpOrderStatus[tmpStatus as keyof typeof tmpOrderStatus]?.title ?? ''} Orders`,
              },
            }))
          }
        }
        setShowSplashScreen(false)
        setTableLoading(false)
      })
  }

  const filterData = (tmpStatus: string) => {
let tmpOrderStatus = resetOrderStatusData(orderStatus)
    setTableLoading(true)
    setTableState(old => ({ ...old, loading: true }));
    if (tableState?.filterText) {
      filterOrdersService(tableState.filterText, '')
        .then(data => {
          if (data) tmpOrderStatus = updateOrderStatus(tmpStatus, data, tmpOrderStatus, true)
        })
        .catch()
        .finally(() => {
          setOrderStatus(tmpOrderStatus)
          setTableLoading(false)
          setTableState(old => ({
            ...old,
            hiddenColumns: {
              ...old.hiddenColumns,
              deliveredDate: true,
              closingDate: true,
            },
            loading: false,
          }));
          setShowSplashScreen(false);
        });
    }
  }

  return (
    <>
      {showPopup && (
        <Popup
          message={popupMessage}
          onClose={handleClosePopup}
        />
      )}
      <PageTitle breadcrumbs={[]} description='#XRS-45670'>Dashboard</PageTitle>
      {showSplashScreen || showPopup === true ? (
        <Loading />
      ) : (
        <>
          <div className='top-cards mb-6'>
            <div className='top-filter'>
              {Object.keys(orderStatus).map((key, index) => {
                const item = orderStatus[key as keyof typeof ORDER_STATUS]
                const cardStatus = key
                return (
                  <button
                    type='button'
                    className='grid-Item-tp'
                    onClick={e => filterOrders(e, cardStatus)}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        filterOrders(e, cardStatus);
                      }
                    }}
                    key={key}
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                  >
                    <TopFilterItem
                      className='card-xl-stretch'
                      svgIcon={item.icon}
                      color={`${cardStatus === status ? 'success' : 'white'}`}
                      iconColor='white'
                      title={String(item.size)}
                      titleColor='primary'
                      description={`${item.title} Orders`}
                      descriptionClasses='text-decoration-underline'
                      descriptionColor='black'
                      status={cardStatus}
                    />
                  </button>
                )
              })}
            </div>
          </div>
          <div className='g-5 gx-xxl-8 border-gray rounded dashboard-table'>
            <OrderTable
              tableState={tableState}
              key={tableInstanceKey}  
              addedPayments={addedPayments}
              setAddedPayments={setAddedPayments}
              className='bg-white new-order-card'
              columns={columns}
              results={results}
              isTableLoading={tableLoading}
              compactLayout
            />
          </div>
        </>
      )}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
